/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer utilities — JSON formatter, Base64 and URL encoding, hash and UUID generators, JWT decoder, cron expression explainer, CSV to JSON and Markdown table generator.`)
};

const es_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilidades para desarrolladores — formateador de JSON, codificación Base64 y URL, generadores de hash y UUID, decodificador de JWT, explicador de expresiones cron, CSV a JSON y generador de tablas Markdown.`)
};

const de_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler-Dienstprogramme — JSON-Formatierer, Base64- und URL-Kodierung, Hash- und UUID-Generatoren, JWT-Decoder, Cron-Ausdrucks-Erklärer, CSV-zu-JSON- und Markdown-Tabellen-Generator.`)
};

const nl_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hulpmiddelen voor ontwikkelaars — JSON-formatter, Base64- en URL-codering, hash- en UUID-generators, JWT-decoder, cron-expressie-uitleg, CSV naar JSON en Markdown-tabelgenerator.`)
};

const fr_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilitaires pour développeurs — formateur JSON, encodage Base64 et URL, générateurs de hash et d’UUID, décodeur JWT, explicateur d’expressions cron, CSV vers JSON et générateur de tableaux Markdown.`)
};

const it_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilità per sviluppatori — formattatore JSON, codifica Base64 e URL, generatori di hash e UUID, decodificatore JWT, spiegatore di espressioni cron, CSV in JSON e generatore di tabelle Markdown.`)
};

const pt_br2_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilitários para desenvolvedores — formatador de JSON, codificação Base64 e URL, geradores de hash e UUID, decodificador de JWT, explicador de expressões cron, CSV para JSON e gerador de tabelas Markdown.`)
};

const pt_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilitários para programadores — formatador de JSON, codificação Base64 e URL, geradores de hash e UUID, descodificador de JWT, explicador de expressões cron, CSV para JSON e gerador de tabelas Markdown.`)
};

const ja_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者向けユーティリティ — JSONフォーマッター、Base64・URLエンコード、ハッシュ・UUID生成、JWTデコーダー、cron式解説、CSVからJSON、Markdownテーブル生成。`)
};

const zh_about_cat_dev = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者实用工具 — JSON 格式化、Base64 与 URL 编码、哈希与 UUID 生成器、JWT 解码器、cron 表达式解析、CSV 转 JSON 以及 Markdown 表格生成器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_dev = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_dev(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_dev", locale)
	if (locale === "en") return en_about_cat_dev(inputs)
	if (locale === "es") return es_about_cat_dev(inputs)
	if (locale === "de") return de_about_cat_dev(inputs)
	if (locale === "nl") return nl_about_cat_dev(inputs)
	if (locale === "fr") return fr_about_cat_dev(inputs)
	if (locale === "it") return it_about_cat_dev(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_dev(inputs)
	if (locale === "pt") return pt_about_cat_dev(inputs)
	if (locale === "ja") return ja_about_cat_dev(inputs)
	return zh_about_cat_dev(inputs)
};